export default __webpack_public_path__ + "static/media/Gossamer Slippers.d30e48db.jpg";